import React from "react";
import { VerificationSuccessStyled } from "../../asset/styled/VerificationSuccessStyled";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Typography from "../../components/common/Typography";
import Button from "../../components/common/Button";
import logoPig from "../../asset/img/link_to_data_step4_img.svg";

const VerificationSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("verificationSuccess");
  const { certifyDate } = useSelector((state) => state.login);
  // 모바일 여부 확인
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);
  const handleMove = () => {
    if(isMobile) {
      navigate("/resultQuery")
    } else {
      let htmKey = sStorage.getItem("htmKey");
      let htmAlias = sStorage.getItem("htmAlias");
      window.location.replace(`https://yearend-web.himgt.net/sp?key=${htmKey}&alias=${htmAlias}`);
    }
  }

  return (
    <VerificationSuccessStyled>
      <div className="success_container">
        <div className="displayFlexColumn" style={{ gap: "16px" }}>
          <img
            src={logoPig}
            alt="Complete"
            style={{ width: "100px", margin: "0 auto" }}
          />
          <div className="displayFlexColumn" style={{ alignItems: "center" }}>
            <Typography className="logo_text">{t("header1")}</Typography>
            <Typography className="desc_text">{certifyDate}</Typography>
          </div>
          <div className="displayFlexColumn" style={{ gap: "10px" }}>
            <Button
              size="large"
              value={t("checkButton")}
              onClick={() => handleMove()}
            />
            <Typography className="desc_text_02">
              {t("checkDescription")}
            </Typography>
          </div>
        </div>
      </div>
    </VerificationSuccessStyled>
  );
};

export default VerificationSuccess;
